import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ReactComponent as LogoVoliaSVG } from '../assets/img/logo-volia-new.svg';
import { ReactComponent as LogoVtvSVG } from '../assets/img/logo-vtv.svg';
import HeroGoLogoImg from '../assets/img/mometu_logo.png';

import scaleSize from '../utils/scale-size';

const LogoStyledContainer = styled.div`
  position: absolute;
  top: ${scaleSize(30)}px;
  left: ${scaleSize(220)}px;
  margin-top: ${(props) => scaleSize(props.hide ? -300 : 0)}px;
  transition: ${({ noAnimation }) => (!noAnimation ? `margin-top ease-out 0.3s` : 'none')};
`;

const Logo = (props) => <LogoStyledContainer {...props} />;

/*
 * This is a good way to add multiple logos
 * and do not extend components logic with conditions
 */
Logo.Volia = styled(LogoVoliaSVG)`
  width: ${scaleSize(220)}px;
  height: ${scaleSize(80)}px;
`;

Logo.VTV = styled(LogoVtvSVG)`
  width: ${scaleSize(220)}px;
  height: ${scaleSize(80)}px;
`;

Logo.HeroGo = styled.div`
  width: ${scaleSize(350)}px;
  height: ${scaleSize(90)}px;
  background: url(${HeroGoLogoImg}) no-repeat;
  background-size: contain;
`;

Logo.Flux = styled.div`
  width: ${scaleSize(350)}px;
  height: ${scaleSize(70)}px;
  background: url('https://flux.hootko.tv/assets/images/logo-flux.png') no-repeat;
  background-size: contain;
`;

Logo.propTypes = {
  hide: PropTypes.bool,
  children: PropTypes.element.isRequired,
};

export default Logo;
